   
$('.c2-list-col .collection_list').flickity({
    contain: true, 
    pageDots: false,
     cellAlign: 'left',
    wrapAround: true, 
    freeScroll: true, // Enables smooth continuous scrolling 
    prevNextButtons: true, 
     groupCells: 2
}); 


function initFlickity() {
    if (window.matchMedia("(max-width: 768px)").matches) {
        $('.c2-icon-text .container.is-justify-center').flickity({
            contain: true, 
            cellAlign: 'left',
            pageDots: false,
            wrapAround: true, 
            freeScroll: true,
            prevNextButtons: false,
            groupCells: 2,
            draggable: true,
            adaptiveHeight: true,
            selectedAttraction: 0.003,
            friction: 0.09
        });
    }
}

 
$(document).ready(initFlickity);
$(window).on('resize', function() {
    // Destroy Flickity if the screen size exceeds the desired range
    if (!window.matchMedia("(max-width: 768px)").matches) {
        $('.c2-icon-text .container.is-justify-center').flickity('destroy');
    } else { 
        initFlickity(); // Reinitialize Flickity if screen size is back to the desired range
    }
});


$(document).on('click', '.add-to-cart-btn', function(e) {
    e.preventDefault();
    var variantId = $(this).data('variant-id');

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: variantId
        },
        dataType: 'json',
        success: function(cart) {
            Shopify.theme.jsAjaxCart.showDrawer();
            Shopify.theme.jsAjaxCart.updateView();
            var scrollTopValue = $('.ajax-cart__product').eq(0).offset().top;
            $('.ajax_cart_main').animate({ scrollTop: scrollTopValue }, 'slow');
        },
        error: function(error) {
            console.error("Error adding to cart:", error); 
        } 
    });
});

 
  
   
$(document).ready(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const currentSort = urlParams.get('sort_by');
   
  if (currentSort) { 
    $(`.inline-options span[data-value="${currentSort}"]`).addClass('active');
  } else {
    $('.inline-options span[data-value="manual"]').addClass('active');
  } 

  $(document).on('click', '.inline-options span', function() {
    $('.inline-options span').removeClass('active');
    $(this).addClass('active');
    
    const sortValue = $(this).data('value');
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    window.location.href = url.toString();
  }); 
});

$(document).ready(function() {  
    $('.collection__tag-filter-btn').on('click', function() {
        $('.c2-slider-faceted-filter-form').toggle();
        $(this).toggleClass('active');
        $('.fillter-overlay').toggleClass('active');
  });

  
  
$(document).ready(function () {
  // Toggle sort filter and overlay on '.name-sort' click
  $('.name-sort').on('click', function () {
    const isActive = $('.collectionSortingFilterOriginal').hasClass('active');

    // Reset visibility and active state
    $('.collectionSortingFilterOriginal').removeClass('active');
    $('.fillter-overlay').removeClass('active'); 
    $('.collection__sort-by-filter').hide();

    // If not already active, show everything
    if (!isActive) {
      $('.collectionSortingFilterOriginal').addClass('active');
      $('.fillter-overlay').addClass('active');
      $('.collection__sort-by-filter').show(); // <-- explicitly show it
    }
  }); 

  // Close all filters on overlay or close button click
  $('.fillter-overlay, .mz-search__navigation--close').on('click', function () {
    $('.fillter-overlay').removeClass('active');
    $('.c2-slider-faceted-filter-form').hide();
    $('.collection__tag-filter-btn').removeClass('active');
  });

    $('.mz-search__navigation--close-sort').on('click', function () {
    $('.collectionSortingFilterOriginal').removeClass('active');
    $('.fillter-overlay').removeClass('active');
    $('.collection__sort-by-filter').hide();
  });
  
});



 
$('.fillter-overlay, .mz-search__navigation--close').on('click', function() {
      $('.c2-slider-faceted-filter-form').hide();
      $('.collection__tag-filter-btn, .fillter-overlay').removeClass('active');
  });
  $('.fillter-overlay, .mz-search__navigation--close-sort').on('click', function() {
     $('.collection__sort-by-filter').hide();
  });
});
 
$(document).on("click", ".menu__heading, .sidebar-block__heading , .filter-btn", function() {
  $(this).parent().toggleClass("menu-open");
});
$(document).on("click", ".sidebar-block__heading", function() {
  $(this).parent().parent().toggleClass("menu-open");
});


// Footer Menu Heading Click Event
$(document).on("click", ".footer__menu .footer__heading", function() { 
  var $parent = $(this).parent();
  var $content = $parent.find('ul'); // Assuming the content to slide is a <ul> inside the parent

  if ($parent.hasClass("menu-open")) {
    $content.stop(true, true).slideUp(300, function() {
      $parent.removeClass("menu-open"); 
    }); 
  } else {
    $(".footer__menu.menu-open").each(function() { 
      var $otherParent = $(this);
      $otherParent.removeClass("menu-open"); 
      $otherParent.find('ul').stop(true, true).slideUp(300);
    });
  
    $content.css('display', 'none'); // Ensure initial state is hidden 
    $parent.addClass("menu-open");
    $content.stop(true, true).slideDown(500);
  } 
});


$(document).on("click", ".c2-mobile-menu-heading-back", function() {
  $('.mobile-menu__list-item input[type=checkbox]:checked').click();
  $('.mobile-menu__toggle-button').removeClass("hide_mobile-menu__toggle-button");
});



